var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartCircle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 267,
    height: 267,
    viewBox: "0 0 267 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_8021_107261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.5 252C201.707 252 257 196.707 257 128.5C257 60.2928 201.707 5 133.5 5C65.2928 5 10 60.2928 10 128.5C10 196.707 65.2928 252 133.5 252Z",
    fill: "#AEDAEA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8021_107261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.984 128.508C241.984 99.7299 230.552 72.1305 210.203 51.7813C189.854 31.4321 162.255 20 133.476 20C104.701 20.0043 77.1056 31.4382 56.7599 51.787C36.4142 72.1357 24.9844 99.7327 24.9844 128.508C24.9844 157.282 36.4147 184.877 56.7609 205.223C77.1071 225.57 104.703 237 133.476 237C162.252 237 189.849 225.57 210.197 205.224C230.546 184.879 241.98 157.283 241.984 128.508Z",
    fill: "#E1F1F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8523 127.821C96.6798 126.615 97.6148 125.537 98.8321 125.537H181.121C182.352 125.537 183.29 126.638 183.096 127.853L176.424 169.499C176.278 170.408 175.531 171.1 174.614 171.176L105.774 176.866C104.719 176.953 103.779 176.204 103.629 175.156L96.8523 127.821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0176 114.746H88.5113L101.551 201.35H163.746M169.864 131.479L162.574 176.989L169.864 131.479ZM171.245 209.46C171.245 211.623 170.386 213.698 168.856 215.228C167.326 216.758 165.251 217.618 163.087 217.618C160.924 217.618 158.849 216.758 157.319 215.228C155.789 213.698 154.93 211.623 154.93 209.46C154.934 207.299 155.795 205.228 157.325 203.702C158.854 202.175 160.927 201.318 163.087 201.318C164.164 201.307 165.232 201.51 166.23 201.914C167.228 202.319 168.136 202.916 168.902 203.673C169.668 204.43 170.276 205.331 170.692 206.324C171.108 207.317 171.323 208.383 171.325 209.46H171.245ZM109.709 209.46C109.709 211.623 108.849 213.698 107.319 215.228C105.789 216.758 103.714 217.618 101.551 217.618C100.479 217.62 99.4171 217.41 98.4264 217.001C97.4357 216.592 96.5356 215.991 95.7777 215.233C95.0198 214.475 94.4189 213.575 94.0097 212.584C93.6005 211.593 93.3909 210.532 93.393 209.46C93.393 208.389 93.6043 207.329 94.0144 206.34C94.4246 205.352 95.0256 204.453 95.7834 203.697C96.5411 202.941 97.4405 202.341 98.4301 201.933C99.4198 201.525 100.48 201.316 101.551 201.318C103.712 201.318 105.784 202.175 107.314 203.702C108.843 205.228 109.704 207.299 109.709 209.46V209.46ZM91.4178 131.479H178.359L171.068 176.989L108.022 182.192L91.4178 131.479Z",
    stroke: "#143961",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5393 148.341H60.0078M80.2255 156.836H53.2148M81.9276 165.331H63.3961",
    stroke: "#143961",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.012 121L115.598 113.748L108 110.489L115.598 107.252L119.012 100L122.402 107.252L130 110.489L122.402 113.748L119.012 121Z",
    fill: "#F15A29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.489 51L106.705 40.2946L96 35.4886L106.705 30.6826L111.489 20L116.295 30.6826L127 35.4886L116.295 40.2946L111.489 51Z",
    fill: "#40B4E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.988 111L141.332 91.6681L122 82.988L141.332 74.3319L149.988 55L158.668 74.3319L178 82.988L158.668 91.6681L149.988 111Z",
    fill: "#EE2A7B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8021_107261",
    x: 0,
    y: 0,
    width: 267,
    height: 267,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8021_107261"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8021_107261",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8021_107261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217,
    height: 217,
    fill: "white",
    transform: "translate(25 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartCircle);
export default __webpack_public_path__ + "static/media/cart-circle.82523db8a1778e4931449266516107da.svg";
export { ForwardRef as ReactComponent };